// src/beta/components/slides/ComparisonSlide.tsx
import type { V1Slide } from '@/beta/types/story';

interface Props { slide: V1Slide; }

/** Comparison slide — before/after split 50/50 with a 1px red vertical rule
 *  down the middle. Corner labels (BEFORE, AFTER), optional bottom caption. */
export function ComparisonSlide({ slide }: Props) {
  const before = slide.block.beforeImageUrl;
  const after = slide.block.afterImageUrl;
  const caption = slide.block.caption ?? undefined;

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', background: '#000', display: 'flex' }}>
      <div style={{ position: 'relative', width: '50%', height: '100%', overflow: 'hidden' }}>
        {before && (
          <img src={before} alt="Before" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        )}
        <div
          style={{
            position: 'absolute',
            top: 'var(--vm-s-3)',
            left: 'var(--vm-s-3)',
            color: 'var(--vm-warm-white)',
            fontFamily: 'var(--vm-font-heading)',
            fontSize: 11,
            letterSpacing: '0.4em',
            textTransform: 'uppercase',
            background: 'rgba(0,0,0,0.55)',
            padding: '6px 10px',
          }}
        >
          Before
        </div>
      </div>

      <div
        data-testid="comparison-rule"
        style={{ width: 1, height: '100%', background: 'var(--vm-red)' }}
      />

      <div style={{ position: 'relative', width: '50%', height: '100%', overflow: 'hidden' }}>
        {after && (
          <img src={after} alt="After" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        )}
        <div
          style={{
            position: 'absolute',
            top: 'var(--vm-s-3)',
            right: 'var(--vm-s-3)',
            color: 'var(--vm-warm-white)',
            fontFamily: 'var(--vm-font-heading)',
            fontSize: 11,
            letterSpacing: '0.4em',
            textTransform: 'uppercase',
            background: 'rgba(0,0,0,0.55)',
            padding: '6px 10px',
          }}
        >
          After
        </div>
      </div>

      {caption && (
        <div
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 'var(--vm-s-4)',
            textAlign: 'center',
            color: 'var(--vm-warm-white)',
            fontFamily: 'var(--vm-font-heading)',
            fontSize: 11,
            letterSpacing: '0.3em',
            textTransform: 'uppercase',
          }}
        >
          {caption}
        </div>
      )}
    </div>
  );
}
